<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.937"
    height="22.23"
    viewBox="0 0 16.937 22.23"
    class="icon icon--password"
  >
    <g transform="translate(0)">
      <path
        fill="#ebebeb"
        d="M78.57,7.41H77.511V5.293a5.293,5.293,0,0,0-10.586,0V7.41H65.867A2.123,2.123,0,0,0,63.75,9.527V20.113a2.123,2.123,0,0,0,2.117,2.117h12.7a2.123,2.123,0,0,0,2.117-2.117V9.527A2.123,2.123,0,0,0,78.57,7.41Zm-6.351-5.4A3.3,3.3,0,0,1,75.5,5.293V7.41H69.043V5.293h-.106A3.3,3.3,0,0,1,72.218,2.011Zm6.351,18.1h-12.7V9.527h12.7Zm-6.351-3.176A2.117,2.117,0,1,0,70.1,14.82,2.123,2.123,0,0,0,72.218,16.937Z"
        transform="translate(-63.75)"
      ></path>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Password',
  };
</script>